// extracted by mini-css-extract-plugin
export default {"mtuPopup":"MTUVideo_mtuPopup__2JoNq"};